<template>
<div class="ui checkbox">
  <input type="checkbox" @change="onChange" :id="id" :name="name">
  <label><slot></slot></label>
</div>
</template>

<script>
export default {
    props: {
        value: {
            required: false,
        },
        id: {
            type: String,
            required: false
        },
        name: {
            type: String,
            required: false
        },
    },
    data: function () {
        return {
            simpleCheck: true
        };
    },
    created: function() {
        this.simpleCheck = _.isUndefined(this.value);
    },
    mounted: function() {
        $('.ui.checkbox').checkbox();
    },
    methods: {
        onChange: function(event) {
            var checked = $(event.target).parent().hasClass('checked');
            var val = this.simpleCheck ? checked : this.value;
            this.$emit('input', val);
            if (checked) {
                this.$emit('check', val);
            } else {
                this.$emit('uncheck', val);
            }
            this.$emit('change', checked, val);
        },
        check: function() {
            // TODO: なぜか$nextTickでは反映されない
            setTimeout(function() {
                $(this.$el).checkbox('set checked');
            }.bind(this), 0);
        }
    }
};
</script>
